import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-text-with-image',
  templateUrl: './text-with-image.component.html',
  styleUrls: ['./text-with-image.component.css'],
})
export class TextWithImageComponent {
  @Input() data!: any;
  @Input() fileName!: string;
  @Input() language!: string;
  selectedImage: string = '';

  openImage(imagePath: string): void {
    this.selectedImage = imagePath;
  }

  getDetailsUrl(object: any): string {
    return `/${this.language}/details/${this.fileName}/${object.title
      .replaceAll(' ', '-')
      .toLowerCase()}`;
  }
}
